



































































import { Component, Vue, Prop, Watch } from "vue-property-decorator";
import axios from "axios";

@Component
export default class SpatialCoverage extends Vue {
    items = [];
    columns = [
        { field: "id", label: "ID", sortable: true },
        { field: "lang_id", label: "Jezik", sortable: true },
        { field: "name", label: "Naziv", sortable: true },
    ];
    private form: any = {};
    private formAdd = false;
    private modal = false;
    @Prop({ required: true })
    isLoading: Boolean = false;

    async load() {
        this.isLoading = true;
        this.items = (
            await axios.get<[]>('lookup/spatial-coverage', {
                headers: {
                    Authorization: "Bearer " + localStorage.token,
                },
            })
        ).data;
        this.isLoading = false;
        this.form = {};
    }

    async mounted() {
        this.load();
    }

    async edit(id: any, lang_code: any) {
        var res = await axios.get<[]>(`lookup/spatial-coverage/${id}/${lang_code}`, {
            headers: {
                Authorization: "Bearer " + localStorage.token,
            },
        });
        this.form = res.data;
        this.formAdd = false;
        this.modal = true;
    }

    async addForm() {
        this.formAdd = true;
        this.modal = true;
    }

    async submitForm() {
        this.form.id = parseInt(this.form.id);
        await axios.post<[]>(`lookup/spatial-coverage/edit`, this.form, {
            headers: {
                Authorization: "Bearer " + localStorage.token,
            },
        });
        this.modal = false;
        this.load();
    }
}
